import { render, staticRenderFns } from "./Propose.vue?vue&type=template&id=30a76919&scoped=true"
import script from "./Propose.vue?vue&type=script&lang=ts"
export * from "./Propose.vue?vue&type=script&lang=ts"
import style0 from "./Propose.vue?vue&type=style&index=0&id=30a76919&prod&lang=scss&scoped=true"
import style1 from "./Propose.vue?vue&type=style&index=1&id=30a76919&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a76919",
  null
  
)

export default component.exports